import { isSafari } from 'react-device-detect';
import { useCallback } from 'react';

export const useSafariArrowScrollFix = () => {
  const preventArrowKeyScroll = useCallback((event: KeyboardEvent) => {
    if (
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }, []);
  const addPreventArrowKeyScroll = useCallback(() => {
    if (isSafari) {
      document.addEventListener('keydown', preventArrowKeyScroll);
    }
  }, []);
  const removePreventArrowKeyScroll = useCallback(() => {
    if (isSafari) {
      document.removeEventListener('keydown', preventArrowKeyScroll);
    }
  }, []);
  return { addPreventArrowKeyScroll, removePreventArrowKeyScroll };
};
